/**
 * Company-Aware Notifications Feature
 * Centralized exports for notification system with company context
 * Clean Code: Single point of import for all notification functionality
 * Company Context: Automatically includes user's company notifications
 */

// Query Hooks - Company-Aware
export {
  useNotifications,
  useNotificationsRealtime,
  useNotificationCountsRealtime,
  useUnreadCount,
  useUnreadCountByType,
  useNotificationCounts,
} from './queries'

// Mutation Hooks - Company-Aware
export {
  useMarkAsRead,
  useMarkAllAsRead,
  useCreateInteractionEvent,
  useCreateRequestEvent,
  useCreateSupportEvent,
  useCreateCompanyAnnouncementEvent,
} from './mutations'

// Types
export type {
  SimplifiedNotification,
  NotificationEvent,
  NotificationCount,
  NotificationFilters,
  GroupedNotification,
  CategoryGroup,
  UINotification,
  CreateNotificationEventInput,
  MarkAsReadInput,
  MarkAllAsReadInput,
  NotificationCountInput,
  RealtimeOptions,
  NotificationDisplayOptions,
  NotificationError,
  NotificationState,
} from './types'

// Utilities
export {
  NotificationConfig,
  isValidNotificationType,
  isValidAudience,
  safeParseTimestamp,
} from './types'

// Query Keys
export { notificationKeys } from './query-keys'

// Utils
export { notificationUtils } from './utils'
